module.exports = __webpack_public_path__ + "img/sales.47499dc9.svg";